/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';


export default function DishDetailsTextContent(props) {
    const { content } = props;

    if (Array.isArray(content)) {
        return (
            <>
                {content.map((p) => (
                    <p key={p.text} className="ny__dishes-details__content paragraph">{p.text}</p>
                ))}
            </>
        );
    }

    return <div dangerouslySetInnerHTML={{ __html: content }} />;
}

DishDetailsTextContent.propTypes = {
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string,
        })),
    ]).isRequired,
};
